import { render } from "./JobDetailEachSpecific.vue?vue&type=template&id=71df096a&scoped=true"
import script from "./JobDetailEachSpecific.vue?vue&type=script&lang=js"
export * from "./JobDetailEachSpecific.vue?vue&type=script&lang=js"

import "./JobDetailEachSpecific.vue?vue&type=style&index=0&id=71df096a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71df096a"]])

export default __exports__